import { MutationOptions, useMutation } from "react-query";
import { API_URL, APIError, APIResponse, post } from "../api";
import { User } from "../@types";

interface VerificationResponse {
  token: string;
  user: User;
  nextStep?: string;
  stage?: string;
  funnelStep?: number;
}

interface VerifyVariables {
  id: string;
  code: string;
}

function use2FA(
  options?: MutationOptions<
    APIResponse<VerificationResponse>,
    APIError,
    VerifyVariables
  >
) {
  const {
    isLoading,
    isError,
    error,
    mutate: verify2FA,
  } = useMutation<APIResponse<VerificationResponse>, APIError, VerifyVariables>(
    async (variables) => {
      return await post(API_URL + "/auth/user/verify-two-factor", variables, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },
    options
  );

  return {
    verify2FA,
    isLoading,
    isError,
    error,
  };
}

export default use2FA;
